import React, { useState, useEffect, useRef } from "react";

import { Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import Select from "react-select";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import { LinkContainer } from "react-router-bootstrap";
import { Button } from "react-bootstrap";
import NavbarNew from "../Components/NavbarNew";

const CreateTicket = () => {
  const [optionForName, setOptionForName] = useState([]);
  const [optionsForAssign, setOptionsForAssign] = useState([]);
  const [optionForTicketCategory, setOptionForTicketCategory] = useState([]);
  const [optionForSubCategory, setOptionForSubCategory] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [ticketError, setTicketError] = useState({});
  const [subCategoryError, setSubCategoryError] = useState({});
  const [customerError, setCustomerError] = useState({});
  const [assignToError, setAssignToError] = useState({});
  const [priorityError, setPriorityError] = useState({});
  const [loading, setLoading] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [assignToEmail, setAssignToEmail] = useState("");
  const [assignToType, setAssignToType] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [executiveId, setExecutiveId] = useState("");
  const [fileArr, setFileArr] = useState([]);
  const [goBackLink, setGoBackLink] = useState("/support-tickets");
  const [getSubCategoryLength, setSubCategoryLength] = useState(0);
  const [customer, setCustomer] = useState({});

  const history = useHistory();

  useEffect(() => {
    let custUrl = environment.dap_url + "users/getUsersByfilters";
    let filter = { userType: "CUSTOMER_USER" };
    let execUrl = environment.dap_url + "support/getAssignedTo";
    let user = JSON.parse(localStorage.getItem("user"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let isPartner = localStorage.getItem("isPartnerLogin");
    if (isPartner) {
      execUrl =
        environment.dap_url + "support/getAssignedToById?id=" + user._id;
      filter = {
        userType: "CUSTOMER_USER",
        parentId: user._id,
        isDeleted: false,
        isActive: true,
      };
      setGoBackLink("/supports");
    }
    if (localStorage.getItem("isSupportAdmin")) {
      execUrl =
        environment.dap_url +
        "support/getAssignedToById?id=" +
        user.createdById;
      filter = {
        userType: "CUSTOMER_USER",
        parentId: user.createdById,
        isDeleted: false,
        isActive: true,
      };
    }
    if (userDetails.data.authority == "SYS_ADMIN") {
      setGoBackLink("/supports");
      execUrl =
        environment.dap_url + "support/getAssignedToById?id=" + user._id;
      filter = {
        userType: "CUSTOMER_USER",
        parentId: user._id,
        isDeleted: false,
        isActive: true,
      };
    }

    axios
      .post(custUrl, {
        filters: filter,
      })
      .then((res) => {
        setOptionForName(
          res.data.map((user) => {
            return {
              name: "customerName",
              value: user._id,
              label: user.userFirstName + " " + user.userLastName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(execUrl)
      .then((res) => {
        setOptionsForAssign(
          res.data.map((user) => {
            return {
              name: "assignedTo",
              value: user._id,
              label: user.userFirstName + " " + user.userLastName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(environment.dap_url + "support/getCategory")
      .then((res) => {
        setOptionForTicketCategory(
          res.data.map((item) => {
            return {
              name: "ticketCategory",
              value: item.categoryName,
              label: item.categoryName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

      const remove = (e, i) => {
        console.log("splice",i);
        let f = [...fileArr];
        const uploadFile = [...uploadFiles];
        uploadFile.splice(i, 1);
        setUploadFiles(uploadFile);
        f.splice(i, 1);
        console.log(f);
        setFileArr(f);
        setData({ ...data, ["attachment"]: uploadFile });
      };

  }, []);

  const getUserById = (id, uType) => {
    axios
      .get(environment.dap_url + "users/" + id)
      .then((res) => {
        console.log(res);
        if (uType == "customer") {
          setCustomerEmail(res.data.email);
          setCustomer(res.data);
        } else {
          setAssignToEmail(res.data.email);
          setAssignToType(res.data.userType);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const formValidation = () => {
    const ticketError = {};
    const subCategoryError = {};
    const customerError = {};
    const priorityError = {};
    const assignedToError = {};

    let isValid = true;
    if (!data.ticketCategory) {
      ticketError.error = "Ticket Category is required";
      isValid = false;
    }
    if (!data.subCategory) {
      if (getSubCategoryLength > 0) {
        subCategoryError.error = "Sub Category is required";
        isValid = false;
      }
    }
    if (!data.customerName) {
      customerError.error = "Customer is required";
      isValid = false;
    }
    if (!data.priority) {
      priorityError.error = "Priority is required";
      isValid = false;
    }
    if (!data.assignedTo) {
      assignedToError.error = "Executive is required";
      isValid = false;
    }

    setTicketError(ticketError);
    setSubCategoryError(subCategoryError);
    setCustomerError(customerError);
    setPriorityError(priorityError);
    setAssignToError(assignedToError);

    return isValid;
  };

  const [data, setData] = useState({
    customerName: "",
    // customerEmail:"",
    customerId: "",
    assignedTo: "",
    assignToName: "",
    ticketCategory: "",
    subCategory: "",
    priority: "",
    attachment: "",
    description: "",
  });

  const optionsForPriority = [
    { name: "priority", value: "Low", label: "Low" },
    { name: "priority", value: "Medium", label: "Medium" },
    { name: "priority", value: "High", label: "High" },
  ];

  const subCategoryRef = useRef(null);
  const customerRef = useRef(null);
  const assignedRef = useRef(null);
  const ticketCategoryRef = useRef(null);
  const priorityRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleChange = (selectedOption) => {
    console.log("event", {
      key: selectedOption.name,
      value: selectedOption.value,
    });
    if (selectedOption.name === "ticketCategory") {
      subCategoryRef.current.state.value = "";
      axios
        .get(
          environment.dap_url +
            "support/getSubCategoryByCategory/?categoryName=" +
            selectedOption.value
        )
        .then((res) => {
          console.log(res.data.length);
          setSubCategoryLength(res.data.length);
          setOptionForSubCategory(
            res.data.map((item) => {
              return {
                name: "subCategory",
                value: item.subCategoryName,
                label: item.subCategoryName,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (selectedOption.name === "customerName") {
      // console.log(selectedOption.label);
      setData({ ...data, customerId: selectedOption.value });
      getUserById(selectedOption.value, "customer");
      // setData({ ...data, customerName: selectedOption.label })
    }
    if (selectedOption.name === "assignedTo") {
      getUserById(selectedOption.value, "executive");
      setData({ ...data, assignedToName: selectedOption.label });
      setData({ ...data, assignedTo: selectedOption.value });
    }
    setData({ ...data, [selectedOption.name]: selectedOption.value });
  };

  const handleChangeforText = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleCancel = () => {
    setData({
      customerId: "",
      customerEmail: "",
      assignedTo: "",
      ticketCategory: "",
      subCategory: "",
      priority: "",
      attachment: "",
      description: "",
    });
    setUploadFiles([]);
    subCategoryRef.current.state.value = "";
    customerRef.current.state.value = "";
    assignedRef.current.state.value = "";
    ticketCategoryRef.current.state.value = "";
    priorityRef.current.state.value = "";
    descriptionRef.current.value = "";
    inputRef.current.value = "";
  };

  const inputRef = useRef(null);
  const handleChangeForFile = (e) => {
    console.log(e.target.name);
    const file = e.target.files[0];
    const f = [...fileArr];
    const uploadFile = [...uploadFiles];
    uploadFile.push(file);
    f.push(URL.createObjectURL(e.target.files[0]));
    setFileArr(f);
    setUploadFiles(uploadFile);
    setData({ ...data, [e.target.name]: uploadFile });
  };

  const remove = (i) => {
    let f = [...fileArr];           
    const uploadFile = [...uploadFiles]; 
    uploadFile.splice(i, 1);       
    setUploadFiles(uploadFile);    
    f.splice(i, 1);                 
    setFileArr(f);               
    setData({ ...data, ["attachment"]: uploadFile }); 
  };
  
  const handelSubmit = (e) => {
    const isValid = formValidation();
    if (isValid) {
      e.preventDefault();
      setLoading(true);
      let status = "assigned";
      if (data.assignedTo === "") {
        data.assignedTo = "N/A";
        status = "created";
      }

      let user = JSON.parse(localStorage.getItem("user"));
      let userDetails = JSON.parse(localStorage.getItem("userDetails"));
      let pid = user.parentId;
      if (localStorage.getItem("isPartnerLogin")) {
        pid = user._id;
      } else if (userDetails.data.authority == "SYS_ADMIN") {
        pid = customer.parentId;
      }

      const formData = new FormData();
      formData.append("role_type", "SUPPORT_ADMIN");
      formData.append("status", status);
      formData.append("customerId", data.customerName);
      formData.append("customerEmail", customerEmail);
      formData.append("assignedTo", data.assignedTo);
      formData.append("ticketCategory", data.ticketCategory);
      formData.append("subcategory", data.subCategory);
      formData.append("priority", data.priority);
      formData.append("description", data.description);
      formData.append("createdBy", user._id);
      formData.append("parentId", pid);

      for (let i = 0; i < uploadFiles.length; i++) {
        console.log("attachment", uploadFiles[i]);
        formData.append("attachment", uploadFiles[i]);
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      console.log(
        formData.forEach((value, key) => {
          console.log(key + " " + value);
        })
      );

      axios
        .post(environment.dap_url + "support/create", formData, config)
        .then((res) => {
          console.log(res);
          Swal.fire({
            icon: "success",
            title: "Ticket Created Successfully",
            showConfirmButton: false,
            timer: 1500,
          }).then((result) => {
            handleCancel();
            history.push(goBackLink);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      e.preventDefault();
      setLoading(false);
    }
  };

 

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />

        <LinkContainer
          to={goBackLink}
          style={{ marginLeft: "50px", marginTop: "20px" }}
        >
          <Button variant="light" className="btn btn-light">
            Go Back
          </Button>
        </LinkContainer>
        <div className="bg-white p-3 mt-5 mx-3">
          <div className="row" style={{ color: "black" }}></div>
          <div className="container-fluid">
            <h4 style={{ display: "inline" }} className="card-title">
              Create Tickets :
            </h4>
          </div>
          <div className="Container-fluid">
            <Form encType="multipart/form-data" >
              <div className="row">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Customer Name:</Form.Label>
                    <Select
                      ref={customerRef}
                      options={optionForName}
                      onChange={handleChange}
                    />
                    <div>
                      {Object.keys(customerError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{customerError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <input
                      name="email"
                      class="form-control"
                      type="text"
                      value={customerEmail}
                      readOnly
                    ></input>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Date: </Form.Label>
                    <Form.Control
                      value={new Date().toLocaleDateString()}
                      disabled
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Assigned to:</Form.Label>
                    <Select
                      ref={assignedRef}
                      onChange={handleChange}
                      options={optionsForAssign}
                    />
                    <div>
                      {Object.keys(assignToError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{assignToError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>

                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <input
                      name="email"
                      class="form-control"
                      type="text"
                      value={assignToEmail}
                      readOnly
                    ></input>
                  </Form.Group>
                </div>

                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Type:</Form.Label>
                    <input
                      name="email"
                      class="form-control"
                      type="text"
                      value={assignToType}
                      readOnly
                    ></input>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Ticket Category:</Form.Label>
                    <Select
                      ref={ticketCategoryRef}
                      onChange={handleChange}
                      options={optionForTicketCategory}
                    />
                    <div>
                      {Object.keys(ticketError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{ticketError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Sub Category:</Form.Label>

                    <Select
                      ref={subCategoryRef}
                      onChange={handleChange}
                      options={optionForSubCategory}
                    />
                    <div>
                      {Object.keys(subCategoryError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>
                            {subCategoryError[key]}
                          </p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Priority:</Form.Label>
                    <Select
                      ref={priorityRef}
                      onChange={handleChange}
                      options={optionsForPriority}
                    />
                    <div>
                      {Object.keys(priorityError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{priorityError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <Form.Group>
                    <Form.Label>Attachment:</Form.Label>
                    <br></br>
                    <input
                      onChange={handleChangeForFile}
                      ref={inputRef}
                      name="attachment"
                      type="file"
                      id="formFileMultiple"
                      multiple
                      accept="image/png, image/gif, image/jpeg,image/svg"
                      style={{ display: "none" }}
                    />
                    <Form.Label htmlFor="formFileMultiple">
                      <button
                        type="button"
                        class="btn btn-primary"
                        onClick={() => inputRef.current.click()}
                        style={{ margin: "5px" }}
                      >
                        Add Pictures
                      </button>
                    </Form.Label>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "10px",
                      }}
                    >
                      {fileArr.map((f, i) => (
                        <div
                          style={{
                            width: "100px",
                            margin: "5px",
                            border: "1px solid black",
                            position: "relative",
                          }}
                        >
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => remove(i)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                          <img src={f} style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                        </div>
                      ))}
                    </div>
                  </Form.Group>
                </div>
                {/* <div className="col-3">
                            <Form.Group >
                            </Form.Group>
                        </div> */}
              </div>
              <div className="row">
                <div className="col-8">
                  <Form.Group>
                    <Form.Label> Description:</Form.Label>
                    <textarea
                      ref={descriptionRef}
                      onChange={handleChangeforText}
                      name="description"
                      class="form-control"
                      rows="3"
                    ></textarea>
                  </Form.Group>
                </div>
              </div>
              <div className="col-4" style={{ marginTop: "2%" }} >
                <button type="submit" class="btn btn-primary" onClick={handelSubmit}>
                  CREATE
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateTicket;
